import Adobe from "../providers/adobe";
import * as MUTATIONS from "../../config/constants/mutation-types";

const pixelDb = {
  triggers: {
    [MUTATIONS.ON_ROUTE]: {
      consulta: ["Adobe.consulta"],
      ofertaCuenta: ["Adobe.ofertaCuenta"],
      datosPersonales: ["Adobe.datosPersonales"],
      datosLaborales: ["Adobe.datosLaborales"],
      informacionAdicional: ["Adobe.informacionAdicional"],
      identidad: ["Adobe.identidad"],
      loadingVeridas: ["Adobe.loadingVeridas"],
      biometriaOK: ["Adobe.biometriaOK"],
      configuracion: ["Adobe.configuracion"],
      contrato: ["Adobe.contrato"],
      thank: ["Adobe.graciasCajaAhorro"],
      mensaje: ["Adobe.mensaje"],
      continuaSucursal: ["Adobe.continuaSucursal"],
      mensajeErrorSolicitudCuenta: ["Adobe.mensaje"],
      celular: ["Adobe.celular"],
      usuarioClave: ["Adobe.usuarioClave"],
      thankOTP: ["Adobe.thankOTP"]
    },
    [MUTATIONS.ON_INTERNAL_LINK]: ["Adobe.internalLink"],
    [MUTATIONS.ADOBE_APP_STARTED]: ["Adobe.appStartedClick"]
  },
  providers: {
    Adobe
  }
};

export default pixelDb;
